goog.provide("shadow.js.shim.module$src$svg$type$tasks$roadmap_svg");
goog.provide("module$shadow_js_shim_module$src$svg$type$tasks$roadmap_svg");
shadow.js.shim.module$src$svg$type$tasks$roadmap_svg = shadow.js.nativeProvides["src/svg/type/tasks/roadmap.svg"] = shadow$bridge("src/svg/type/tasks/roadmap.svg");
module$shadow_js_shim_module$src$svg$type$tasks$roadmap_svg.default = shadow.js.shim.module$src$svg$type$tasks$roadmap_svg;
